import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=103f19ae&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=103f19ae&lang=css"
import style1 from "./customer.vue?vue&type=style&index=1&id=103f19ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103f19ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103f19ae')) {
      api.createRecord('103f19ae', component.options)
    } else {
      api.reload('103f19ae', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=103f19ae&scoped=true", function () {
      api.rerender('103f19ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/customerQualityDashboard/component/customer.vue"
export default component.exports